import React from 'react';

import { string, number, bool, shape, oneOf } from 'prop-types';

import ClassNames from 'classnames';

import { CircularProgress, LinearProgress } from '@material-ui/core';

import BaseComponent from '../../.internal/BaseComponent';

import './Progress.scss';

/**
 * @deprecated
 */
export default class Progress extends BaseComponent {
  render() {
    const { type, percentage, style, id, className } = this.props;

    const classes = ['Progress', className];

    const classNames = ClassNames(classes);

    let progressType = null;

    const progressProps = {
      value: percentage,
      style,
      id,
      className: classNames
    };

    switch (type) {
      case 'bar':
        progressType = (
          <LinearProgress variant="determinate" {...progressProps} />
        );
        break;
      case 'circle':
        progressType = (
          <CircularProgress variant="determinate" {...progressProps} />
        );
        break;
      default:
        break;
    }

    return <>{progressType}</>;
  }
}

Progress.propTypes = {
  type: oneOf(['bar', 'circle']),
  percentage: number,
  showPercentage: bool,
  style: shape({}),
  id: string,
  className: string
};

Progress.defaultProps = {
  type: 'bar',
  percentage: 0,
  showPercentage: false,
  style: {},
  id: undefined,
  className: undefined
};
